import React, { createContext, useContext, useRef } from 'react';
import NotificationAlert from 'react-notification-alert';

const NotificationContext = createContext(null);

export const NotificationProvider = ({ children }) => {
  const ref = useRef(null);

  const notify = (place = 'tr', type = 'info', msg = '', icon = 'icon-bell-55') => {
    if (!ref.current) return;
    const options = {
      place,
      message: (
        <div>
          <div>{msg}</div>
        </div>
      ),
      type,
      icon: `tim-icons ${icon}`,
      autoDismiss: 7,
    };
    ref.current.notificationAlert(options);
  };

  return (
    <NotificationContext.Provider value={{ notify }}>
      <div className="react-notification-alert-container">
        <NotificationAlert ref={ref} />
      </div>
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotification = () => {
  const ctx = useContext(NotificationContext);
  if (!ctx) return { notify: () => {} };
  return ctx;
};

export default NotificationContext;
